import React from 'react';
import stl from './PersonCard.module.css';
import SvgTiponIcon from "../../assets/icons/SvgTiponIcon";

const PersonCard = ({ person, onPersonSelect, imgClassName = '' , description }) => {
    const handleClick = () => {
        if (typeof onPersonSelect === 'function') {
            onPersonSelect(person);
        }
    };
    return (
        <div
            className={stl.personCard}
            onClick={handleClick}
        >
            <div className={stl.personImgBox}>
                <img src={person?.photo} alt={'employee photo'} className={`${stl.personImg} ${imgClassName}`} />
                <div className={stl.personBrandBox}>
                    <SvgTiponIcon/>
                </div>
            </div>
            <div>
                <h3 className={stl.personName}>{person?.name}</h3>
                {description && <p className={stl.personReason}>{person?.description}</p>}
            </div>
        </div>
    );
};

export default PersonCard;
